/**
 * 리포트 공유 — Mini App 표현층
 *
 * Slack 은 모달마다 [🔗 공유링크 생성] 버튼이 있는데 텔레그램에는 그 수단이 없었다.
 *
 * 새로 링크를 만들 필요는 없다. 이 화면의 주소가 곧 공유 링크(/export/<hash>)다 —
 * 봇이 그 링크로 보낸 것을 열어서 보고 있기 때문이다. 그래서 서버 왕복이 없다.
 *
 * 텔레그램 안에서는 t.me 공유 시트를 띄우고(대화 상대를 골라 바로 전달),
 * 그게 막히면 클립보드로 떨어뜨린다.
 */
import React, { useState } from 'react';
import { haptic, tg } from '../../hooks/useTelegram';

const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (e) {
        // 구형 웹뷰는 clipboard API 가 없다. execCommand 로 떨어진다.
        try {
            const el = document.createElement('textarea');
            el.value = text;
            el.style.position = 'fixed';
            el.style.opacity = '0';
            document.body.appendChild(el);
            el.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(el);
            return ok;
        } catch (e2) {
            return false;
        }
    }
};

/**
 * 공유할 주소.
 *
 * `window.location.href` 를 쓰면 안 된다. Mini App 은 주소 뒤에
 * `#tgWebAppData=…&tgWebAppThemeParams={"section_header_text_color":…}` 를 붙이는데,
 * 테마 값이야 잡음일 뿐이지만 **`tgWebAppData` 는 본인의 initData(계정 정보 + 서명)다.**
 * 남에게 보내는 링크에 실릴 것이 아니다. 경로만 남긴다 — 그것이 곧 공유 링크다.
 */
const shareUrl = () => `${window.location.origin}${window.location.pathname}`;

export const ShareReport = ({ title }) => {
    const [copied, setCopied] = useState(false);
    const url = shareUrl();

    const share = () => {
        haptic('medium');
        const webApp = tg();
        const link =
            'https://t.me/share/url?url=' +
            encodeURIComponent(url) +
            '&text=' +
            encodeURIComponent((title || 'PaperInsight 리포트').slice(0, 120));

        if (webApp?.openTelegramLink) {
            webApp.openTelegramLink(link);
            return;
        }
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const copy = async () => {
        haptic('light');
        const ok = await copyToClipboard(url);
        setCopied(ok);
        if (ok) setTimeout(() => setCopied(false), 2000);
    };

    return (
        <section className="tg-share">
            <button type="button" className="tg-share-btn is-primary" onClick={share}>
                📤 공유하기
            </button>
            <button type="button" className="tg-share-btn" onClick={copy}>
                {copied ? '✅ 복사됨' : '🔗 링크 복사'}
            </button>
        </section>
    );
};

export default ShareReport;
